import { useId } from "react";
import { Flex, HelpIndicator, Tag } from "@jsq/ds/core";
import { programTagRenderer } from "./styles_vanilla.css";

const EMPTY = "--";

export interface ProgramTagRendererProps {
  /** Assigned compliance program name (compliance-backend external_object→program). */
  program?: string | null;
  testId: string;
}

/**
 * Program cell for the Entities and Clients settings grids: the assigned program as a
 * badge (with an "<program> program is enabled" tooltip), or "--" with a
 * "No program assigned yet" tooltip.
 */
export const ProgramTagRenderer = ({ program, testId }: ProgramTagRendererProps) => {
  // Unique per rendered cell so tooltip ids don't collide across grid rows.
  const idBase = useId();

  // The Flex keeps the badge hugging its label instead of filling the cell width
  return (
    <Flex className={programTagRenderer} gap={2} alignItems="center">
      {program ? (
        <HelpIndicator
          id={`${idBase}-program`}
          placement="top"
          content={`${program} program is enabled`}
        >
          <Tag data-testid={testId} label={program} variant="neutral" />
        </HelpIndicator>
      ) : (
        <HelpIndicator id={`${idBase}-empty`} placement="top" content="No program assigned yet">
          <span>{EMPTY}</span>
        </HelpIndicator>
      )}
    </Flex>
  );
};

export default ProgramTagRenderer;
